<!--    
@description 详情弹出框
@author zhijie.huang
@date 2018/9/27
@version v1.1.0

/**** mixin ****/
dialog from './mixins/dialog'

/**** props ****/
// 详细元素配置
detailData: [
  {
    label: String,
    key: String
  }
],
// 数据
model: '',
// 取消回调
cancelFun: Function,
// 取消文案
cancelLabel: String,
-->
<template>
  <el-dialog :closeOnClickModal="false"
    :title="title"
    :visible.sync="iVisible"
    :width="iWidth">
    <el-form :ref="id+'form'"
      :label-width="iLabelWidth"
      :model="model">
      <el-form-item v-for="(item) in detailData"
        :key="item.key"
        :label="item.label"
        :prop="item.key"
        input-width="auto"
        class="el-form-item--detail">

        <p v-text="item.type == 'select' ? item.select[model[item.key]] : model[item.key]"></p>
      </el-form-item>
    </el-form>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="e_cancel">{{ cancelLabel }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import dialog from "./mixins/dialog";

export default {
  mixins: [dialog],
  data() {
    return {};
  },
  watch: {},
  computed: {},
  props: {
    detailData: {
      type: Array,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    cancelFun: {
      type: Function,
      default: null
    },
    cancelLabel: {
      type: String,
      default() {
        return this.$t("common.close");
      }
    }
  },
  methods: {
    e_cancel() {
      this.iVisible = false;
      this.cancelFun && this.cancelFun();
    }
  }
};
</script>
<style scoped>
.el-form-item--detail {
  margin-bottom: 5px;
}
.el-form-item--detail p {
  word-break: break-all;
}
</style>
